module.exports = __webpack_public_path__ + "img/gestoPare.a36b8588.png";